import { Component } from '@angular/core';
import { NgClass } from '@angular/common';
import { Router, NavigationEnd, ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';

import { AccountService } from './_services';
import { Account, Role } from './_models';
import { AlertComponent } from './_components';

@Component({
    selector: 'app',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.css'],
    standalone: true,
    imports: [NgClass, RouterLink, RouterLinkActive, RouterOutlet, AlertComponent]
})
export class AppComponent {
    Role = Role;
    account: Account;
    showNavBar = true;
    constructor(
        private accountService: AccountService,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {
        this.accountService.account.subscribe(x => this.account = x);

        // Toggle nav bar visibility based on route data
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => this.activatedRoute),
            map(route => {
                while (route.firstChild) route = route.firstChild;
                return route;
            }),
            filter(route => route.outlet === 'primary'),
            mergeMap(route => route.data)
        ).subscribe(data => {
            this.showNavBar = data.hideNav !== true;
        });
    }

    logout() {
        this.accountService.logUTrackEvent('Logout', this.account.email);
        this.accountService.logout();
    }
}